@if (idle.warningVisible()) {
  <div class="idle-backdrop">
    <div class="idle-dialog" role="alertdialog" aria-modal="true" aria-labelledby="idle-title" aria-describedby="idle-msg" (keydown)="onKeydown($event)">
      <h2 id="idle-title" class="idle-dialog__title">{{ 'idleTimeout.title' | translate }}</h2>
      <p id="idle-msg" class="idle-dialog__msg">{{ 'idleTimeout.message' | translate: { time: time() } }}</p>
      <div class="idle-dialog__actions">
        <button #logoutBtn type="button" class="idle-dialog__logout" (click)="idle.logoutNow()">{{ 'profile.logout' | translate }}</button>
        <button #stayBtn type="button" class="idle-dialog__stay" (click)="idle.extend()">{{ 'idleTimeout.staySignedIn' | translate }}</button>
      </div>
    </div>
  </div>
}
